import React from "react";
// mock 
import { Link as RouterLink } from 'react-router-dom';
import { getMenus } from "../../utils/protector";
import { Box, Link,   Typography, Avatar, FormControl, Select, MenuItem } from '@mui/material';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { styled } from '@mui/material/styles';
//
// import navConfig from './NavConfig';
// component
import Iconify from '../../components/Iconify';
import HTTPManager from "../../utils/httpRequestManager";
import Loader from "../../components/Loader";
// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const AccountStyle = styled('div')(({ theme }) => ({
    display: 'flex', 
    flexDirection:'column',
    padding: theme.spacing(2, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: theme.palette.grey[500_12],
  }));

export default class NavigationMenu extends React.Component{
  httpManager = new HTTPManager();
    constructor(){
        super();
        this.state = {
            userDetail : {},
            sideMenuItems : [],
            mercantsList:[],
            isLoading: false,
            reviewMerchantsList:[]
        }

        this.staticMenus = this.staticMenus.bind(this)
        this.dynamicMenus = this.dynamicMenus.bind(this)
    }

    componentDidMount(){ 
        var userstr = window.localStorage.getItem('userdetail');
        if(userstr !== '' && userstr !== undefined){
          var details = JSON.parse(userstr);
          this.setState({userDetail:  details}, ()=>{ 
              this.dynamicMenus(details)
            // this.staticMenus(details)
          })
        }
    }

    dynamicMenus(details){
      var menus = getMenus() 
      //console.log(menus)
      if(details.userType === 'CN'){ 
        this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
          this.setState({reviewMerchantsList: response.data},()=>{ 
              var items = [ 
                  {
                      title: 'dashboard',
                      path: '/app',
                      icon: getIcon('eva:pie-chart-2-fill'),
                  },
                  {
                    title: 'plans',
                    path: '/app/plans',
                    icon: getIcon('mdi:notebook'),
                  }
                ]

              if(menus.indexOf('Region') !== -1 || details.userRole === 'SuperAdmin'){
                items.push({
                  title: 'Region Management',
                  path: '/app/region',
                  icon: getIcon('mdi:apache-kafka')
                })
              }

              if(details.userRole=== 'SuperAdmin'){
                items.push({
                  title: 'User Management',
                  icon: getIcon('mdi:account-cog'),
                  children: [
                    {
                      title: 'Castlenova Employees',
                      path: '/app/employees'
                    },
                    {
                      title: 'Master Agents',
                      path: '/app/masteragents'
                    },
                    {
                      title: 'Agents',
                      path: '/app/agents'
                    },
                  ]
                }) 
              }
              else if(menus.indexOf('Staff') !== -1 || menus.indexOf('MasterAgents') !== -1 || menus.indexOf('Agents') !== -1){
                var childmenu = [] 
                    if(menus.indexOf('Staff') !== -1 ){
                      childmenu.push({
                        title: 'Castlenova Employees',
                        path: '/app/employees'
                      })
                    }

                    if(menus.indexOf('MasterAgents') !== -1 ){
                      childmenu.push({
                        title: 'Master Agents',
                        path: '/app/masteragents'
                      })
                    }

                    if(menus.indexOf('Agents') !== -1 ){
                      childmenu.push({
                        title: 'Agents',
                        path: '/app/agents'
                      })
                    } 
                items.push({
                  title: 'User Management',
                  icon: getIcon('mdi:account-cog'),
                  children: childmenu
                })
              }
              //console.log(menus)
              if(details.userRole=== 'SuperAdmin'){ 
                items.push({
                  title: 'Business Management',
                  icon: getIcon('mdi:account-cog'),
                  children: [
                    {
                      title: 'My Merchants',
                      path: '/app/merchants/approved'
                    },
                    {
                      title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                      path: '/app/merchants/review'
                    },
                    {
                      title: 'Rejected Merchants',
                      path: '/app/merchants/rejected'
                    },
                    {
                      title: 'Deactivated Merchants',
                      path: '/app/merchants/deactivated'
                    }
                  ]
                }) 
              }
              else if(menus.indexOf('AssignToMe') !== -1 || menus.indexOf('AssignToStaff') !== -1 || menus.indexOf('AssignToMA') !== -1 || menus.indexOf('AssignToA') !== -1 || menus.indexOf('Unassign') !== -1 || menus.indexOf('EditMerchant') !== -1 || menus.indexOf('Rejected') !== -1 ||menus.indexOf('Deactivated') !== -1){
                var childmenum = []
                childmenum.push({
                  title: 'My Merchants',
                  path: '/app/merchants/approved'
                })
                if(menus.indexOf('AssignToMe') !== -1 || menus.indexOf('AssignToStaff') !== -1 || menus.indexOf('AssignToMA') !== -1 || menus.indexOf('AssignToA') !== -1 || menus.indexOf('Unassign') !== -1 || menus.indexOf('EditMerchant') !== -1 ){
                  childmenum.push({
                    title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                    path: '/app/merchants/review'
                  })
                }

                if(menus.indexOf('Rejected') !== -1){
                  childmenum.push({
                    title: 'Rejected Merchants',
                    path: '/app/merchants/rejected'
                  })
                }

                if(menus.indexOf('Deactivated') !== -1){
                  childmenum.push({
                    title: 'Deactivated Merchants',
                    path: '/app/merchants/deactivated'
                  })
                }
                items.push({
                  title: 'Business Management',
                  icon: getIcon('mdi:account-cog'),
                  children: childmenum
                })
              } 
              this.setState({sideMenuItems: items});
          });
        });
      } 
      if(details.userType === 'MA'){
        this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
          this.setState({reviewMerchantsList: response.data},()=>{
              let items = [
                  // {
                  //   title: 'dashboard',
                  //   path: '/merchant',
                  //   icon: getIcon('eva:pie-chart-2-fill'),
                  // },
                  {
                      title: 'dashboard',
                      path: '/app',
                      icon: getIcon('eva:pie-chart-2-fill'),
                  }, 
                  {
                    title: 'User Management',
                    icon: getIcon('mdi:account-cog'),
                    children: [
                      {
                        title: 'Agents',
                        path: '/app/agents'
                      },
                    ]
                  },
                  {
                    title: 'Business Management',
                    icon: getIcon('mdi:account-cog'),
                    children: [
                      {
                        title: 'My Merchants',
                        path: '/app/merchants/approved'
                      },
                      {
                        title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                        path: '/app/merchants/review'
                      },
                      {
                        title: 'Rejected Merchants',
                        path: '/app/merchants/rejected'
                      },
                      {
                        title: 'Deactivated Merchants',
                        path: '/app/merchants/deactivated'
                      },
                      
                    ]
                }
              ]
              this.setState({sideMenuItems: items});
            });

          });
      }
      if(details.userType === 'A'){ 
          this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
            this.setState({reviewMerchantsList: response.data}, ()=>{
              let items = [
                  // {
                  //   title: 'dashboard',
                  //   path: '/merchant',
                  //   icon: getIcon('eva:pie-chart-2-fill'),
                  // },
                  {
                      title: 'dashboard',
                      path: '/app',
                      icon: getIcon('eva:pie-chart-2-fill'),
                  }, 
                  {
                    title: 'Business Management',
                    icon: getIcon('mdi:account-cog'),
                    children: [
                      {
                        title: 'My Merchants',
                        path: '/app/merchants/approved'
                      },
                      {
                        title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                        path: '/app/merchants/review'
                      },
                      {
                        title: 'Rejected Merchants',
                        path: '/app/merchants/rejected'
                      },
                      {
                        title: 'Deactivated Merchants',
                        path: '/app/merchants/deactivated'
                      },
                      
                    ]
                }
              ]
              this.setState({sideMenuItems: items});
            });
          });
      }

      if(details.userType === 'M'){
        this.httpManager.getRequest('/merchant/getMerchants').then(response=>{
          this.setState({mercantsList: response.data})
        })
        if(details.userRole === 'Owner'){
          let items = [
              // {
              //   title: 'dashboard',
              //   path: '/merchant',
              //   icon: getIcon('eva:pie-chart-2-fill'),
              // },
              {
                  title: 'dashboard',
                  path: '/app',
                  icon: getIcon('eva:pie-chart-2-fill'),
              }, 
              {
                title: 'Employee',
                path: '/app/employee',
                icon: getIcon('mdi:account-cog'), 
              },
              {
                title: 'Roles',
                path: '/app/roles',
                icon: getIcon('mdi:security'), 
              },
              {
                title: 'Customer',
                path: '/app/customer',
                icon: getIcon('mdi:account-group')
              },
              {
                title: 'Gift Cards',
                path: '/app/giftcards',
                icon: getIcon('mdi:gift')
              },
              {
                  title: 'Inventory', 
                  icon: getIcon('mdi:sitemap'),
                  children: [
                    {
                      title: 'Category',
                      path: '/app/category'
                    },
                    {
                      title: 'Products',
                      path: '/app/product'
                    },
                  ]
              }, 
              {
                title: 'Settings',
                icon: getIcon('mdi:cog'),
                children: [ 
                    {
                      title: 'Default Commission Payment',
                      path: '/app/commissionpayment'   
                    },
                    {
                      title: 'Default Discount Division',
                      path: '/app/defaultdiscount'   
                    },
                    {
                      title: 'Discount',
                      path: '/app/discount'
                    },
                    {
                      title: 'Tax',
                      path: '/app/tax'   
                    },
                    {
                      title: 'Employee Specific Setting',
                      path: '/app/employeesetting'   
                    },
                    {
                      title: 'Loyalty Points Setting',
                      path: '/app/loyaltypointsettings'   
                    },
                    {
                      title:'Tip Suggestion Settings',
                      path:'/app/tipsuggestion'
                    },
                    {
                      title:'PrinterDrivers',
                      path:'/app/PrinterDriverDownload'
                    },
                    {
                      title:'Message Settings',
                      path:'/app/reasons'
                    }
                    // {
                    //   title: 'Loyalty Redeem Point Settings',
                    //   path: '/app/loyaltyredeemsettings'   
                    // }  ,
                    // {
                    //   title: 'Loyalty Program',
                    //   path: '/app/loyaltyactivatesettings'   
                    // }  
                ]
            },
            {
                title: 'Transactions',
                path: '/app/transactions',
                icon: getIcon('mdi:cash-clock'),
            }, 
            {
                title: 'payroll',
                path: '/app/payout',
                icon: getIcon('mdi:chart-arc'),
            }, 
            {
              title: 'report',
              path: '/app/reports',
              icon: getIcon('mdi:file-chart'),
          },  
          {
            title: 'Batch Reports',
            path: '/app/batches',
            icon: getIcon('mdi:select-group'), 
          },
          ]
          this.setState({sideMenuItems: items});
        }
        else{
          var items = [ 
            {
                title: 'dashboard',
                path: '/app',
                icon: getIcon('eva:pie-chart-2-fill'),
            }
          ]


          if(menus.indexOf('Employee') !== -1){
            items.push({
              title: 'Employee',
              path: '/app/employee',
              icon: getIcon('mdi:account-cog'), 
            })
          } 
          if(menus.indexOf('Customer') !== -1){
            items.push({
              title: 'Customer',
              path: '/app/customer',
              icon: getIcon('mdi:account-group')
            })
          }
          if(menus.indexOf('GiftCard') !== -1){
            items.push({
              title: 'Gift Cards',
              path: '/app/giftcards',
              icon: getIcon('mdi:gift')
            })
          }
          if(menus.indexOf('Inventory') !== -1){
            items.push({
                title: 'Inventory', 
                icon: getIcon('mdi:sitemap'),
                children: [
                  {
                    title: 'Category',
                    path: '/app/category'
                  },
                  {
                    title: 'Products',
                    path: '/app/product'
                  },
                ]
            })
          }

          var childmenus = [];

          if(menus.indexOf('DefaultCommission') !== -1){
            childmenus.push({
              title: 'Default Commission Payment',
              path: '/app/commissionpayment'   
            })
          }
          if(menus.indexOf('DefaultDiscount') !== -1){
            childmenus.push({
              title: 'Default Discount Division',
              path: '/app/defaultdiscount'   
            })
          }
          if(menus.indexOf('Discount') !== -1){
            childmenus.push({
              title: 'Discount',
              path: '/app/discount'
            })
          }
          if(menus.indexOf('Tax') !== -1){
            childmenus.push({
              title: 'Tax',
              path: '/app/tax'
            })
          }
          if(menus.indexOf('EmpSettings') !== -1){
            childmenus.push({
              title: 'Employee Specific Setting',
              path: '/app/employeesetting'   
            })
          }
          if(menus.indexOf('LoyaltyPoints') !== -1){
            childmenus.push({
              title: 'Loyalty Points Setting',
              path: '/app/loyaltypointsettings'   
            })
          }

          if(menus.indexOf('TipSuggestions') !== -1){
            childmenus.push({
              title:'Tip Suggestion Settings',
              path:'/app/tipsuggestion'   
            })
          }

          if(menus.indexOf('PrinterDriverDownloadPrinterDrivers') !== -1){
            childmenus.push({
              title:'PrinterDrivers',
              path:'/app/PrinterDriverDownload'   
            })
          }
          
          if(childmenus.length > 0){
            items.push({
              title: 'Settings',
              icon: getIcon('mdi:cog'),
              children: childmenus
            }) 
          }

          if(menus.indexOf('Transactions') !== -1){
            items.push({
              title: 'Transactions',
              path: '/app/transactions',
              icon: getIcon('mdi:cash-clock'),
            })
          }

          if(menus.indexOf('Payout') !== -1){
            items.push({
              title: 'payroll',
              path: '/app/payout',
              icon: getIcon('mdi:chart-arc'),
            })
          }

          if(menus.indexOf('Report') !== -1){
            items.push({
              title: 'report',
              path: '/app/reports',
              icon: getIcon('mdi:file-chart'),
            })
          } 
          this.setState({sideMenuItems: items});
        }
      }
    }


    staticMenus(details){
      if(details.userType === 'CN' && details.userRole === 'SuperAdmin'){ 
        this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
          this.setState({reviewMerchantsList: response.data},()=>{
            //console.log(response.data.length)
              let items = [
                  // {
                  //   title: 'dashboard',
                  //   path: '/merchant',
                  //   icon: getIcon('eva:pie-chart-2-fill'),
                  // },
                  {
                      title: 'dashboard',
                      path: '/app',
                      icon: getIcon('eva:pie-chart-2-fill'),
                  },
                  {
                      title: 'Region Management',
                      path: '/app/region',
                      icon: getIcon('mdi:apache-kafka')
                  },
                  {
                      title: 'User Management',
                      icon: getIcon('mdi:account-cog'),
                      children: [
                        {
                          title: 'Castlenova Employees',
                          path: '/app/employees'
                        },
                        {
                          title: 'Master Agents',
                          path: '/app/masteragents'
                        },
                        {
                          title: 'Agents',
                          path: '/app/agents'
                        },
                      ]
                  },
                  {
                    title: 'Business Management',
                    icon: getIcon('mdi:account-cog'),
                    children: [
                      {
                        title: 'My Merchants',
                        path: '/app/merchants/approved'
                      },
                      {
                        title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                        path: '/app/merchants/review'
                      },
                      {
                        title: 'Rejected Merchants',
                        path: '/app/merchants/rejected'
                      },
                      {
                        title: 'Deactivated Merchants',
                        path: '/app/merchants/deactivated'
                      },
                      
                    ]
                }
              ]
              this.setState({sideMenuItems: items});
          });
        });
      } 
      if(details.userType === 'CN' && details.userRole === 'Admin'){ 
        //console.log("asdasdasdasqweqwe123412423")
        this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
          this.setState({reviewMerchantsList: response.data},()=>{
            //console.log("asdasdasdasqweqwe123412423")
              let items = [ 
                  {
                      title: 'dashboard',
                      path: '/app',
                      icon: getIcon('eva:pie-chart-2-fill'),
                  }, 
                  {
                      title: 'Region Management',
                      path: '/app/region',
                      icon: getIcon('mdi:apache-kafka')
                  },
                  {
                      title: 'User Management',
                      icon: getIcon('mdi:account-cog'),
                      children: [
                        {
                          title: 'Castlenova Employees',
                          path: '/app/employees'
                        },
                        {
                          title: 'Master Agents',
                          path: '/app/masteragents'
                        },
                        {
                          title: 'Agents',
                          path: '/app/agents'
                        },
                      ]
                  },
                  {
                    title: 'Business Management',
                    icon: getIcon('mdi:account-cog'),
                    children: [
                      {
                        title: 'My Merchants',
                        path: '/app/merchants/approved'
                      },
                      {
                        title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                        path: '/app/merchants/review'
                      },
                      {
                        title: 'Rejected Merchants',
                        path: '/app/merchants/rejected'
                      },
                      {
                        title: 'Deactivated Merchants',
                        path: '/app/merchants/deactivated'
                      },
                      
                    ]
                }
              ]
              this.setState({sideMenuItems: items}, ()=>{
                //console.log(this.state.sideMenuItems)
              });
          });
        });
      }
      if(details.userType === 'CN' && details.userRole === 'Staff'){ 
          this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
              this.setState({reviewMerchantsList: response.data},()=>{
              let items = [
                  // {
                  //   title: 'dashboard',
                  //   path: '/merchant',
                  //   icon: getIcon('eva:pie-chart-2-fill'),
                  // },
                  {
                      title: 'dashboard',
                      path: '/app',
                      icon: getIcon('eva:pie-chart-2-fill'),
                  }, 
                  {
                    title: 'Business Management',
                    icon: getIcon('mdi:account-cog'),
                    children: [
                      {
                        title: 'My Merchants',
                        path: '/app/merchants/approved'
                      },
                      {
                        title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                        path: '/app/merchants/review'
                      },
                      {
                        title: 'Rejected Merchants',
                        path: '/app/merchants/rejected'
                      },
                      {
                        title: 'Deactivated Merchants',
                        path: '/app/merchants/deactivated'
                      },
                      
                    ]
                }
              ]
              this.setState({sideMenuItems: items});
            });
          });
      }
      if(details.userType === 'MA'){
          this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
            this.setState({reviewMerchantsList: response.data},()=>{
                let items = [
                    // {
                    //   title: 'dashboard',
                    //   path: '/merchant',
                    //   icon: getIcon('eva:pie-chart-2-fill'),
                    // },
                    {
                        title: 'dashboard',
                        path: '/app',
                        icon: getIcon('eva:pie-chart-2-fill'),
                    }, 
                    {
                      title: 'User Management',
                      icon: getIcon('mdi:account-cog'),
                      children: [
                        {
                          title: 'Agents',
                          path: '/app/agents'
                        },
                      ]
                    },
                    {
                      title: 'Business Management',
                      icon: getIcon('mdi:account-cog'),
                      children: [
                        {
                          title: 'My Merchants',
                          path: '/app/merchants/approved'
                        },
                        {
                          title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                          path: '/app/merchants/review'
                        },
                        {
                          title: 'Rejected Merchants',
                          path: '/app/merchants/rejected'
                        },
                        {
                          title: 'Deactivated Merchants',
                          path: '/app/merchants/deactivated'
                        },
                        
                      ]
                  }
                ]
                this.setState({sideMenuItems: items});
              });

            });
      }
      if(details.userType === 'A'){ 
          this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
            this.setState({reviewMerchantsList: response.data}, ()=>{
              let items = [
                  // {
                  //   title: 'dashboard',
                  //   path: '/merchant',
                  //   icon: getIcon('eva:pie-chart-2-fill'),
                  // },
                  {
                      title: 'dashboard',
                      path: '/app',
                      icon: getIcon('eva:pie-chart-2-fill'),
                  }, 
                  {
                    title: 'Business Management',
                    icon: getIcon('mdi:account-cog'),
                    children: [
                      {
                        title: 'My Merchants',
                        path: '/app/merchants/approved'
                      },
                      {
                        title: 'Review Merchants ('+this.state.reviewMerchantsList.length+')',
                        path: '/app/merchants/review'
                      },
                      {
                        title: 'Rejected Merchants',
                        path: '/app/merchants/rejected'
                      },
                      {
                        title: 'Deactivated Merchants',
                        path: '/app/merchants/deactivated'
                      },
                      
                    ]
                }
              ]
              this.setState({sideMenuItems: items});
            });
          });
      }
      if(details.userType === 'M'){
        this.httpManager.getRequest('/merchant/getMerchants').then(response=>{
          this.setState({mercantsList: response.data})
        })
        let items = [
            // {
            //   title: 'dashboard',
            //   path: '/merchant',
            //   icon: getIcon('eva:pie-chart-2-fill'),
            // },
            {
                title: 'dashboard',
                path: '/app',
                icon: getIcon('eva:pie-chart-2-fill'),
            }, 
            {
              title: 'Employee',
              path: '/app/employee',
              icon: getIcon('mdi:account-cog'), 
            },
            {
              title: 'Customer',
              path: '/app/customer',
              icon: getIcon('mdi:account-group')
            },
            {
              title: 'Gift Cards',
              path: '/app/giftcards',
              icon: getIcon('mdi:gift')
            },
            {
                title: 'Inventory', 
                icon: getIcon('mdi:sitemap'),
                children: [
                  {
                    title: 'Category',
                    path: '/app/category'
                  },
                  {
                    title: 'Products',
                    path: '/app/product'
                  },
                ]
            }, 
            {
              title: 'Settings',
              icon: getIcon('mdi:cog'),
              children: [ 
                  {
                    title: 'Default Commission Payment',
                    path: '/app/commissionpayment'   
                  },
                  {
                    title: 'Default Discount Division',
                    path: '/app/defaultdiscount'   
                  },
                  {
                    title: 'Discount',
                    path: '/app/discount'
                  },
                  {
                    title: 'Tax',
                    path: '/app/tax'   
                  },
                  {
                    title: 'Employee Specific Setting',
                    path: '/app/employeesetting'   
                  },
                  {
                    title: 'Loyalty Points Setting',
                    path: '/app/loyaltypointsettings'   
                  },
                  // {
                  //   title: 'Loyalty Redeem Point Settings',
                  //   path: '/app/loyaltyredeemsettings'   
                  // }  ,
                  // {
                  //   title: 'Loyalty Program',
                  //   path: '/app/loyaltyactivatesettings'   
                  // }  
              ]
          }
        ]
        this.setState({sideMenuItems: items});
      }
    }

    changeMerchantToken(merchantId){
      this.setState({isLoading: true}, ()=>{
          this.httpManager.postRequest('/merchant/changeMerchantToken', {merchantId: merchantId}).then(response=>{
              window.localStorage.setItem('token', response.token);
              window.localStorage.setItem('userdetail',JSON.stringify(response.userdetail));
              this.setState({isLoading: false, userDetail: response.userdetail})
              window.location.href="/";
          })
      })
      
    }

    render(){
        return  <Scrollbar
          sx={{
            height: 1,
            '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
          }}
        >
          {this.state.isLoading && <Loader />}
          <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
            <Logo height={70}/>
          </Box>
    
          <Box sx={{ mb: 5, mx: 2.5 }}>
            <Link underline="none" component={RouterLink} to="#">
              <AccountStyle>
                <div style={{display:'flex'}}>
                <Avatar src={'/static/icons/avataricon.png'} style={{maxHeight:'40px'}} alt="photoURL" />
                <Box sx={{ ml: 2 }}>
                  <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                    {this.state.userDetail.firstName+" "+this.state.userDetail.lastName}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {this.state.userDetail.userRole}
                  </Typography>
                </Box>
                </div>
 
                {this.state.userDetail.userType === 'M' &&  <FormControl fullWidth> 
                    <Select 
                    variant='standard' 
                    value={this.state.userDetail.merchantId}
                    onChange={(e)=>{
                        this.changeMerchantToken(e.target.value)
                    }} 
                    >
                      {this.state.mercantsList.map(elmt=>(
                          <MenuItem value={elmt.merchantId}>{elmt.merchantName}</MenuItem> 
                      ))} 
                    </Select>
                </FormControl>}

              </AccountStyle>
            </Link>
          </Box>
    
          <NavSection navConfig={this.state.sideMenuItems}/>
    
          <Box sx={{ flexGrow: 1 }} /> 
        </Scrollbar>
    }

}